import Navbar from './HERO-SECTION/Navbar';
import Header from './HERO-SECTION/Header';



function App() {
  return (
    <>
      <Navbar />
      <Header />
    </>
  );
}

export default App;
